import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CarbonFilter } from '../interfaces/carbon-filter';

@Injectable({
  providedIn: 'root'
})
export class CharacteristicConsultListService {
  filters: BehaviorSubject<CarbonFilter> = new BehaviorSubject({} as CarbonFilter);

  isSetDate: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  patchFilters(patch: Partial<CarbonFilter>): void {
    const merged = this.normalize({ ...this.filters.value, ...patch });
    this.emitIfChanged(merged);
  }

  setFilters(filters: CarbonFilter): void {
    this.emitIfChanged(this.normalize(filters));
  }

  private emitIfChanged(next: CarbonFilter): void {
    if (!this.shallowCompare(this.filters.value, next)) {
      this.filters.next(next);
    }
  }

  private normalize(f: CarbonFilter): CarbonFilter {
    const out: CarbonFilter = { ...f };
    const trim = (s?: string | null) => (typeof s === 'string' ? s.trim() : s);

    out.carbonCreditCode = trim(out.carbonCreditCode) || undefined;
    out.registerCode = trim(out.registerCode) || undefined;
    out.holderCode = trim(out.holderCode) || undefined;
    out.initialDate = trim(out.initialDate as string) || undefined;
    out.finalDate = trim(out.finalDate as string) || undefined;

    if (out.initialDate && out.finalDate) {
      out.filterByInsertDate = true;
    } else {
      delete out.filterByInsertDate;
    }

    return out;
  }

  shallowCompare(a: any, b: any): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    const ak = Object.keys(a);
    const bk = Object.keys(b);
    if (ak.length !== bk.length) return false;
    for (const k of ak) {
      if (a[k] !== b[k]) return false;
    }
    return true;
  }
}
